import React from 'react';
import Dashboard  from '@flows/Dashboard';

const AdminDashboard = () => (
    <Dashboard type="admin" />
);

export default AdminDashboard;
